<template>
  <span>{{ diffString }}</span>
</template>
<script type="text/javascript">
import UTILS from "@/utils/utils.js";
export default {
  data: function() {
    return {
      diffString: "0 day 00:00:00"
    };
  },
  props: {
    st: {
      type: String,
      default: ""
    },
    et: {
      type: String,
      default: ""
    }
  },
  mounted: function() {
    this.startTimer();
  },
  methods: {
    startTimer: function() {
      let vm = this;
      let interval = window.setInterval(function() {
        let timeDiff = UTILS.timeDiff(vm.st);
        let timeDiffString =
          UTILS.prefixInteger(timeDiff.hour, 2) +
          ":" +
          UTILS.prefixInteger(timeDiff.minute, 2) +
          ":" +
          UTILS.prefixInteger(timeDiff.second, 2);
          if(timeDiff.day>1){
            timeDiffString = timeDiff.day + "days " + timeDiffString;
          }else{
            timeDiffString = timeDiff.day + "day " + timeDiffString;
          }
        
        vm.diffString = timeDiffString;
        // Vue.set(vm, 'diffString', timeDiffString)
        if (timeDiff.total == 0) {
          window.clearInterval(interval);
        }
      }, 1000);
    }
  }
};
</script>
